require("@fancyapps/fancybox");
// require('sticky-kit/dist/sticky-kit.min.js');
require("@fancyapps/ui");

import { Helpers } from './helpers.js'

// let helpers = new Helpers();

export class Parts{

    init() {
      this.careersMore();
      this.filterFunc();
      this.pageSidebarSticky();
      this.scrollMenuSelector();
      this.scrollTrigger();
      this.productsRecommendations();
      this.newsletterTrigger();
      this.accountBlockTriggers();
    }    
  
  accountBlockTriggers() {
    $('.account--orders__trigger').on('click', function () {
      $('.account--block').removeClass('active');
      $('.order--block').toggleClass('active');
    })

    $('.account--password__trigger').on('click', function () {
      $('.account--block').removeClass('active');
      $('.password-reset--block').toggleClass('active');
    })

    $('.account--data__trigger').on('click', function () {
      $('.account--block').removeClass('active');
      $('.data--block').toggleClass('active');
    })
  }
  
  newsletterTrigger() {
    $('.modal--close').on('click', function () {
      $('.submit--container').addClass('show');
    }, false);

    $('.modal--close').on('click', function () {
      $('.submit--container').removeClass('show');
    })
  }
  
  productsRecommendations() {
    var loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(".product-recommendations");
      if (productRecommendationsSection === null) { return; }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        }
      };
      request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
      if (event.detail.sectionId === "product-recommendations") {
        loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
  }
  

    pageSidebarSticky(){

      if($('.menu--sidebar.sticky').length == 0) return;

      //jQuery needs to be called instead of $
      jQuery('.menu--sidebar.sticky').stick_in_parent();

    }

    scrollTrigger() {

      if($('.section--anchors').length == 0) return;

      $(window).scrollTop($(window).scrollTop()+1);
      $(window).on("scroll", function () {
        parts.scrollMenuSelector();
      });

    }


    scrollMenuSelector() {

      if($('.section--anchors').length == 0) return;

      var sections = $('.section--anchor');
      var targetMenu = $('.menu--sidebar');

      sections.each(function () {
        var activeSection = $(this);

        if (helpers.isInScrollableViewport(activeSection)) {
          var activeSectionIndex = activeSection.data('section-index');
          var currentTimelineNavBar = targetMenu.find(
            '[data-section-index="' + activeSectionIndex + '"]'
          );
          currentTimelineNavBar.addClass('active');

          console.log(currentTimelineNavBar);

          targetMenu.find('a').not(currentTimelineNavBar).removeClass('active');

        }
      });
    }

    filterFunc(){

        if($('.filter--trigger').length == 0) return;

        var triggerOnClick = $('.filter--trigger');

        triggerOnClick.on('click', function() {
          var targetContainer = $(this).closest('.has-children').find('.filter-dropdown');

          targetContainer.toggleClass('active');
          $(this).toggleClass('active');

        });


    }

    careersMore (){

      let triggerOnClick = $('.button--more');
      let targetObject = $('.career-content');

      triggerOnClick.on('click', () => {
        targetObject.toggleClass('open');
        triggerOnClick.toggleClass('show');
      });

    }


}
